import { Injectable } from '@angular/core';
import {HttpService} from '../http.service';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {

  constructor(private httpService: HttpService, private router: Router) { }

  private quoteURL = 'quote';

  private quotePath = '/quote/';
  private quotesPath = '/quotes';
  private newQuotePath = '/newquote/';

  public jobOnsite = 'O';
  public jobParts = 'S';


  private customerquotePath = 'customerquote';

  getQuotes(page): Observable<any>{
    return this.httpService.httpGet(this.quoteURL + '?page=' + page).pipe(response => {
      return response;
    });
  }

  getCustomerQuotes(customerID, page): Observable<any>{
    return this.httpService.httpGet(this.customerquotePath + '/' + customerID + '?page=' + page).pipe(response => {
      return response;
    });
  }

  getQuote(quoteID): Observable<any>{
    return this.httpService.httpGet(this.quoteURL + '/' + quoteID).pipe(response => {
      return response;
    });
  }

  updateQuote(body): Observable<any> {
    return this.httpService.httpPut(this.quoteURL, body).pipe(response => {
      return response;
    });

  }

  createQuote(body): Observable<any> {
    return this.httpService.httpPost(this.quoteURL, body).pipe(response => {
      return response;
    });

  }

  openQuote(quoteID){
    this.router.navigate([this.quotePath, quoteID]);
  }

  openQuotes(id){
    this.router.navigate([this.quotesPath, id]);
  }

  newQuote(customerID){
    this.router.navigate([this.newQuotePath, customerID]);
  }
}
